import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=3e8f1e22&"
import script from "./ShopView.vue?vue&type=script&lang=js&"
export * from "./ShopView.vue?vue&type=script&lang=js&"
import style0 from "./ShopView.vue?vue&type=style&index=0&id=3e8f1e22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports